import brandAPI from '@/app/apis/main/brands/brands-api.js';

export default {
	/**
	 * @return {object} brand list
	 * @params {queryParams} - productType
	 * */
	async getBrands(queryParams) {
		return brandAPI.getBrands(queryParams);
	},

	async updateStatusBrand(id,body) {
		return brandAPI.updateStatusBrand(id,body);
	},

	/**
	 * @params {object} brandDetails
	 * */
	async addBrand(brandDetails) {
		return brandAPI.addBrand(brandDetails);
	},

	/**
	 * @params {object} brandDetails
	 * @params brandId
	 * */
	async updateBrand(brandId, brandDetails) {
		return brandAPI.updateBrand(brandId, brandDetails);
	},

	/**
	 * @params brandId
	 * */
	 async deleteBrand(brandId) {
		return brandAPI.deleteBrand(brandId);
	},
}